import { createFileRoute } from "@tanstack/react-router";
import { requireFeature } from "@/lib/feature-gate";
import { SidebarInset } from "@/components/ui/sidebar";
import { DashboardHeader } from "@/components/dashboard-header";
import { ApprovalInbox } from "@/components/supervisor/approvals/ApprovalInbox";
import PageHeader from "@/components/reusable-components/header/page-header";

export const Route = createFileRoute("/supervisor/_layout/approvals")({
  beforeLoad: () => requireFeature("leave"),
  component: ApprovalsPage,
});

function ApprovalsPage() {
  return (
    <SidebarInset>
      <DashboardHeader />
      <div className="space-y-4 p-6 pt-0">
        <PageHeader
          title="Leave Approvals"
          description="Requests waiting on your decision. Approve or reject with a note."
        />
        <ApprovalInbox />
      </div>
    </SidebarInset>
  );
}
